<template>
  <div id="message">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">姓名/账号:</div>
        <Select
          @on-change="changeInput"
          v-model="userId"
          filterable
          :remote-method="remoteMethod"
          :loading="loading1"
        >
          <Option
            v-for="(option, index) in userList"
            :value="option.id"
            :key="index"
          >{{option.username}}{{option.phone}}</Option>
        </Select>
      </div>
    </div>
    <Table style="font-size:20px" border stripe :columns="columns1" :data="TemplateData">
      <template slot-scope="{ row, index }" slot="config">
        <Button style="margin-left: 10px;" @click="Delete(row)">删除</Button>
      </template>
    </Table>
    <Modal v-model="configMessage" :title="configTitle" width="700px" @on-ok="updatedMessage">
      <div class="config">
        <div class="title">用户</div>
        <Select
          v-model="updated.userId"
          filterable
          :remote-method="remoteMethod"
          :loading="loading1"
        >
          <Option
            v-for="(option, index) in userList"
            :value="option.id"
            :key="index"
          >{{option.username}}{{option.phone}}</Option>
        </Select>
      </div>
      <div class="config">
        <div class="title">关键词</div>
        <Input v-model="updated.keywords" placeholder="关键词"></Input>
      </div>
    </Modal>
    <Modal v-model="deleteOk" title="删除！！" @on-ok="ok">删除！！！</Modal>
    <Button @click="Add()" style="float: right;margin-top: 15px;">新增</Button>
    <Page @on-change="pagingSuery" style="margin-top:15px;float: left;" :total="total"></Page>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "message",
  data() {
    return {
      pageNow: 1,
      deleteOk: false,
      configTitle: "",
      loading1: false,
      configMessage: false,
      keyword: "",
      userList: [{ id: "", username: "" }],
      updated: { keywords: "", userId: "" },
      total: 0,
      userId: "",
      TemplateData: [],
      columns1: [
        {
          title: "用户ID",
          align: "center",
          key: "userId"
        },
        {
          title: "关键词",
          align: "center",
          key: "keywords"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime"
        },

        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "config"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },

  methods: {
    remoteMethod(query) {
      this.loading1 = true;
      api
        .UserList({
          pageNow: 1,
          keyword: query,
          pageNow: this.pageNow,
          pageSize: 10
        })
        .then(res => {
          this.userList = res.body.data.list;
          this.loading1 = false;
        });
    },
    getData() {
      api
        .ProductShieldUserQueryList({
          pageNow: this.pageNow,
          userId: this.userId
        })
        .then(res => {
          this.total = res.body.data.total;
          this.TemplateData = res.body.data.list;
        });
    },
    changeInput() {
      this.pageNow = 0;
      this.getData();
    },
    Add() {
      this.configTitle = "新增";
      this.configMessage = true;
      this.userList = [{}];
    },

    updatedMessage() {
      api.ProductShieldUserAdd(this.updated).then(res => {
        this.$Message.info(res.body.message);
        this.getData();
      });
    },
    Delete(res) {
      this.updated = res;
      this.deleteOk = true;
    },
    ok() {
      api.ProductShieldUserDel(this.updated.id).then(res => {
        this.$Message.info(res.body.message);
        this.getData();
      });
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    }
  }
};
</script>

<style scoped  >
#message {
  height: 100%;
  overflow: hidden;
}
.config {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.title {
  float: left;
  width: 200px;
}
</style>